import React, { useEffect, useState } from 'react';
import { Presentation, Download, Copy, Check } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Admin: auto-generated LinkedIn carousel (8 slides + PDF) for the Recovery Revolution article.
export default function RecoveryCarouselCard() {
  const token = sessionStorage.getItem('admin_token');
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState('');

  useEffect(() => {
    fetch(`${API_URL}/api/admin/recovery/carousel`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then(setData)
      .catch(console.error);
  }, [token]);

  const copyText = async (id, text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      ta.remove();
    }
    setCopied(id);
    setTimeout(() => setCopied(''), 1600);
  };

  if (!data?.slides) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5" data-testid="recovery-carousel-card">
      <div className="flex items-center gap-2 mb-1">
        <Presentation className="w-4 h-4 text-sky-500" />
        <h3 className="text-sm font-bold text-gray-900">Recovery Revolution — LinkedIn Carousel</h3>
        <span className="px-2 py-0.5 text-[10px] font-bold bg-sky-50 text-sky-600 rounded uppercase tracking-wider">{data.slides.length} slides</span>
      </div>
      <p className="text-xs text-gray-400 mb-4">
        Auto-generated from the research doc. Upload the PDF as a LinkedIn document post, paste the caption.
      </p>
      <div className="flex gap-1.5 overflow-x-auto pb-2 mb-3" data-testid="recovery-carousel-strip">
        {data.slides.map((s, i) => (
          <a key={s} href={`${API_URL}${s}`} target="_blank" rel="noopener noreferrer" className="shrink-0">
            <img src={`${API_URL}${s}`} alt={`Slide ${i + 1}`} className="w-24 h-24 rounded border border-gray-200 object-cover" />
          </a>
        ))}
      </div>
      <div className="flex flex-wrap gap-1.5">
        <a
          href={`${API_URL}${data.pdf}`}
          className="inline-flex items-center gap-1 px-2 py-1 rounded bg-gray-900 text-white text-[10px] font-semibold"
          data-testid="recovery-carousel-pdf"
        >
          <Download className="w-3 h-3" /> PDF (LinkedIn)
        </a>
        <button
          onClick={() => copyText('li', data.caption)}
          className="inline-flex items-center gap-1 px-2 py-1 rounded bg-lime-100 hover:bg-lime-200 text-lime-800 text-[10px] font-semibold"
          data-testid="recovery-carousel-copy-caption"
        >
          {copied === 'li' ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />} LinkedIn caption
        </button>
        {data.zip && (
          <a
            href={`${API_URL}${data.zip}`}
            className="inline-flex items-center gap-1 px-2 py-1 rounded bg-fuchsia-600 text-white text-[10px] font-semibold"
            data-testid="recovery-carousel-zip"
          >
            <Download className="w-3 h-3" /> Slides ZIP (Instagram)
          </a>
        )}
        {data.ig_caption && (
          <button
            onClick={() => copyText('ig', data.ig_caption)}
            className="inline-flex items-center gap-1 px-2 py-1 rounded bg-fuchsia-100 hover:bg-fuchsia-200 text-fuchsia-800 text-[10px] font-semibold"
            data-testid="recovery-carousel-copy-ig"
          >
            {copied === 'ig' ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />} IG caption + hashtags
          </button>
        )}
      </div>
    </div>
  );
}
